/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { Field, formValueSelector } from 'redux-form';
import { addValidator, required } from 'redux-form-validators';
import { uniqueId } from 'lodash';
import FieldAnswerItem from './components/FieldAnswerItem/FieldAnswerItem';
import './style.module.scss';
import AnswerType3 from './components/AnswerType3/AnswerType3';
import AnswerType4 from './components/AnswerType4/AnswerType4';
import AnswerType5 from './components/AnswerType5/AnswerType5';
import { Col, Row } from 'reactstrap';
import { MdQuestionAnswer } from 'react-icons/md';
import InputField from '../../../../../../helpers/Fields/InputField';
import AnswerType6 from './components/AnswerType6/AnswerType6';
import AnswerType7 from './components/AnswerType7/AnswerType7';

const answerValidator = addValidator({
  validator: function (options, value, allValues) {
    if (value.text || value.url) {
      return true;
    }
    return {
      // id: 'form.errors.private_url',
      defaultMessage: options.msg || 'Is requred',
      // msg: options.msg,
    };
  },
});

function Answers({ rootChange, questionType, answers, formatMessage }) {
  console.log("🚀 ~ file: Answers.jsx ~ line 27 ~ Answers ~ answers", answers)
  return (
    <div className={'Answers'}>
      <div className={'title'}>{formatMessage('questionAnswer')}</div>
      {questionType == 'type3' && (
        <div className={'text'}>{formatMessage('answerOrderSort')}</div>
      )}
      {questionType == 'type1' && (
        <Field
          name="answers"
          placeholder={formatMessage('changeText')}
          component={InputField}
          validate={[required()]}
        />
      )}
      {(questionType == 'type2' || questionType == 'type3') && (
        <div className={'items'}>
          {answers &&
            Array.isArray(answers) &&
            answers.map((answer, index) => (
              <Field
                key={'answer-' + index}
                name={`answers[${index}]`}
                placeholder={formatMessage('changeText')}
                component={FieldAnswerItem}
                isCheckTrue={questionType == 'type2'}
                onDelete={index > 1 ? () => {
                  rootChange('answers', [
                    ...(answers.filter((_i, i) => i != index)),
                  ]);
                  console.log("🚀 ~ file: Answers.jsx ~ line 61 ~ onDelete ~ answer", answer)
                } : null}
                validate={
                  [
                    answerValidator({
                      msg: 'Is requred',
                    }),
                  ]
                }
              />
            ))}
          
            <div
              className={'itemCreate'}
              onClick={() => {
                rootChange('answers', [
                  ...answers,
                  {
                    _id: uniqueId('answer-') + Date.now(),
                    text: '',
                    url: '',
                    order: answers.length + 1,
                    isTrue: false,
                  },
                ]);
              }}
            >
              {/* <MdQuestionAnswer size="100" /> */}
              <div className={'text'}>{formatMessage('addAnswerItem')}</div>
            </div>
          
        </div>
      )}
      {questionType == 'type4' && (
        <AnswerType4 answers={answers} rootChange={rootChange} formatMessage={formatMessage} />
      )}
      {questionType == 'type5' && (
        <AnswerType5 answers={answers} rootChange={rootChange} formatMessage={formatMessage} />
      )}
      {questionType == 'type6' && (
        <AnswerType6 answers={answers} rootChange={rootChange} formatMessage={formatMessage} />
      )}
      {questionType == 'type7' && (
        <AnswerType7 answers={answers} rootChange={rootChange} formatMessage={formatMessage} />
      )}
    </div>
  );
}

export default Answers;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/Answers.jsx